module.exports = __webpack_public_path__ + "media/images/flags/16/Tanzania-7a2ce95ad9085949da8b9ddde0d0ac45.png";